module.exports = __webpack_public_path__ + "static/media/book_back.ff8fde92.jpg";